import React, { useEffect, useState } from 'react'
import Loading from '../../Loading'
import { postObtenerNPCCentrosMP } from '../../../services/Contratacion'
import ModalCrearCuentasMP from './ModalCrearCuentasMP'
import ModalModificarNPCCentrosMP from './ModalModificarNPCCentrosMP'
import ModalEliminarNPCCentroMP from './ModalEliminarNPCCentroMP'

const ModalNPCCentros = ({setmodalOnNPCCentros,dataUnMaestroProcedimiento}) => {
    const [dataNPCCentros, setdataNPCCentros]=useState([])
    const [loading,setloading]=useState(true)
    const [modalOnCrearNPCCentros, setmodalOnCrearNPCCentros]=useState(false)
    const [modalOnModificarNPCCentros, setmodalOnModificarNPCCentros]=useState(false)
    const [modalOnEliminarNPCCentros, setmodalOnEliminarNPCCentros]=useState(false)
    const [actualizarData, setactualizarData]=useState('')
    const [modificarData, setmodificarData]=useState('')
    const [eliminarData, seteliminarData]=useState('')

    const handleCancelarClick=()=>{
        setmodalOnNPCCentros(false)
    }

    useEffect(()=>{
        const consulta={
            'PRCODI': dataUnMaestroProcedimiento.PRCODI
        }
        setloading(false)
        postObtenerNPCCentrosMP(consulta).then((res)=>{
            //console.log(res.data.data,'centrosssss')
            setloading(true)
            setdataNPCCentros(res.data.data)
        })
    },[actualizarData])

    const handleOnclickCrear=()=>{
      setmodalOnCrearNPCCentros(true)
    }

    const handleOnClickModificar=(item)=>{      
      setmodificarData(item)
      setmodalOnModificarNPCCentros(true)
    }

    const handleOnClickEliminar=(item)=>{
      seteliminarData(item)
      setmodalOnEliminarNPCCentros(true)
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)]   mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              NPC Centros
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            
              <div className="flex  text-left">
                
                <div className="w-1/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Código
                  </label>
                  
                  <input
                    disabled={true}
                    defaultValue={dataUnMaestroProcedimiento.PRCODI}
                    name='codigo'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                    
                  </div>
                  <div className="w-2/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Descripción
                  </label>
                  
                  <input
                    disabled={true}
                    defaultValue={dataUnMaestroProcedimiento.PrNomb}
                    name='nombre'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                    
                  </div>
                  
                  
              </div>
              <div className='p-2'>
              <button
                                        onClick={handleOnclickCrear}
                                        type="button"
                                        className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                                    >
                                        Crear
                                    </button>
              </div>
              
            
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-4 inline-block min-w-full">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center bg-gray-200">
                      <thead className="">
                        <tr>
                            <th></th>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900"
                          >
                            
                          </th>
                        
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Vigencia
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Empresa
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Centro Costo
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Cuenta de Costo
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Cuenta de Ingreso
                          </th>
                        </tr>
                      </thead>
                      <tbody >
                        {loading?
                            dataNPCCentros.map((item,index)=>(
                                <tr className=" divide-y divide-slate-700 " key={index}>
                                    <td></td>
                                    <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                    <button
                                        onClick={()=>handleOnClickModificar(item)}
                                        type="button"
                                        className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                                    >
                                        Modificar
                                    </button>
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                    <button
                                        onClick={()=>handleOnClickEliminar(item)}
                                        type="button"
                                        className="inline-block px-2 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
                                    >
                                        Eliminar
                                    </button>
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                        {item.PrcVig}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                        {item.PrEmpCt1V}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                        {item.PrcCCosV}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                        {item.PrcCtaCosV}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                        {item.PrcCtaIngV}
                                    </td>
                                </tr>
                            ))
                            :
                            
                            <tr className=" divide-y divide-slate-700 ">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><Loading/></td>
                                <td></td>
                                <td></td>
                            </tr>
                        
                        }                     
                       </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            
          </div>
        </div>
      </div>
      {modalOnCrearNPCCentros? <ModalCrearCuentasMP setmodalOnCrearNPCCentros={setmodalOnCrearNPCCentros} dataUnMaestroProcedimiento={dataUnMaestroProcedimiento} setactualizarData={setactualizarData}/>:null}
      {modalOnModificarNPCCentros? <ModalModificarNPCCentrosMP setmodalOnModificarNPCCentros={setmodalOnModificarNPCCentros} dataUnMaestroProcedimiento={dataUnMaestroProcedimiento} setactualizarData={setactualizarData} modificarData={modificarData}/>:null}
      {modalOnEliminarNPCCentros? <ModalEliminarNPCCentroMP setmodalOnEliminarNPCCentros={setmodalOnEliminarNPCCentros} eliminarData={eliminarData} setactualizarData={setactualizarData} />:null}
    </div>
  )
}

export default ModalNPCCentros